import { render, staticRenderFns } from "./upsellSelection.vue?vue&type=template&id=45280fc4&scoped=true&"
import script from "./upsellSelection.vue?vue&type=script&lang=js&"
export * from "./upsellSelection.vue?vue&type=script&lang=js&"
import style0 from "./upsellSelection.vue?vue&type=style&index=0&id=45280fc4&prod&lang=scss&scoped=true&"
import style1 from "./upsellSelection.vue?vue&type=style&index=1&id=45280fc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45280fc4",
  null
  
)

export default component.exports